import { composeHomeRows as e } from "./composeHomeRows.mjs";
import { useGuestHomePersonalQuery as t } from "./useGuestHomePersonalQuery.mjs";
import { useGuestHomeQuery as n } from "./useGuestHomeQuery.mjs";
import { useIsAuthenticated as r } from "@maat/store-auth";
import { useEffect as i, useMemo as a, useState as o } from "react";
//#region src/properties/useGuestHomeRows.ts
var s = 1500, c = () => {
	let c = r(), l = n(), u = t(), [d, f] = o(!0);
	i(() => {
		let e = setTimeout(() => f(!1), s);
		return () => clearTimeout(e);
	}, []);
	let p = l.data?.rows, m = u.data?.rows, h = a(() => e({
		publicRows: p ?? [],
		personalRows: m ?? []
	}), [p, m]), g = l.isPending || c && u.isPending && d, _ = l.isError;
	return {
		rows: h,
		window: l.data?.window,
		isLoading: g,
		isError: _,
		isEmpty: !g && !_ && h.length === 0,
		refetch: () => Promise.all([l.refetch(), c ? u.refetch() : Promise.resolve()])
	};
};
//#endregion
export { s as HOME_PERSONAL_PATIENCE_MS, c as useGuestHomeRows };
